<div class="surface-section">
  <div class="grid grid-nogutter">
    <div
      class="col-12 lg:col-6 h-full px-4 py-4 md:py-8 md:px-6 lg:px-8 content"
    >
      <section class="surface-section pb-5 md:px-6 lg:px-0">
        <ul class="list-none flex gap-3 flex-row justify-content-between p-0">
          <li
            class="flex align-items-center flex-column gap-2 relative w-full"
          >
            <!-- Start::icon -->
            <div
              class="flex justify-content-center align-items-center border-circle bg-primary-100 w-3rem h-3rem z-1"
            >
              <i class="pi pi-check text-xl text-primary-600"></i>
            </div>
            <!-- End::icon -->
            <div
              class="w-full block absolute left-50 bg-primary-500 hidden"
              style="transform: translateY(-50%); height: 2px; top: 25%"
            ></div>
            <div class="flex flex-column align-items-center">
              <h1
                class="m-0 font-medium text-900 text-sm md:text-base line-height-3 text-center"
              >
                Contacto
              </h1>
            </div>
          </li>
          <li
            class="flex align-items-center flex-column gap-2 relative w-full"
          >
            <div
              class="flex justify-content-center align-items-center border-circle w-3rem h-3rem z-1"
              [ngClass]="step() >= 2 ? 'bg-primary-100' : 'surface-200'"
            >
              <i
                class="fa-sharp fa-solid fa-truck text-xl"
                [ngClass]="step() >= 2 ? 'text-primary-600' : 'text-600'"
              ></i>
            </div>
            <div
              class="w-full block absolute right-50 hidden"
              style="transform: translateY(-50%); height: 2px; top: 25%"
              [ngClass]="step() >= 2 ? 'bg-primary-500' : 'surface-300'"
            ></div>
            <div
              class="w-full hidden lg:block absolute left-50 surface-300 hidden"
              style="transform: translateY(-50%); height: 2px; top: 25%"
            ></div>
            <div class="flex flex-column align-items-center">
              <h1
                class="m-0 font-medium text-900 text-sm md:text-base line-height-3 text-center"
              >
                Entrega
              </h1>
            </div>
          </li>

          <li
            class="flex align-items-center flex-column gap-2 relative w-full"
          >
            <div
              class="w-full block absolute right-50 hidden"
              [ngClass]="step() == 3 ? 'bg-primary-500' : 'surface-300'"
              style="transform: translateY(-50%); height: 2px; top: 25%"
            ></div>
            <div
              class="flex justify-content-center align-items-center border-circle w-3rem h-3rem z-1"
              [ngClass]="step() == 3 ? 'bg-primary-100' : 'surface-200'"
            >
              <i
                class="fa-sharp fa-solid fa-credit-card text-xl"
                [ngClass]="step() === 3 ? 'text-primary-600' : 'text-600'"
              ></i>
            </div>
            <div class="flex flex-column align-items-center">
              <h1
                class="m-0 font-medium text-900 text-sm md:text-base line-height-3 text-center"
              >
                Pago
              </h1>
            </div>
          </li>
        </ul>
      </section>
      <div class="grid formgrid">
        @if(step() === 1){
        <app-contact-step #contactStepComponent />
        } @else if(step() === 2){
        <app-shipping-step #shippingStepComponent />
        } @else if(step() === 3){
        <app-payment-step #paymentStepComponent />
        }

        <div
          class="flex flex-column justify-content-center align-items-center lg:justify-content-end mt-6 gap-2 md:gap-3 fixed lg:static left-0 bottom-0 surface-card w-full p-3 lg:p-0 z-2 shadow-8 lg:shadow-none"
        >
          <!-- Start::resumen en móvil -->
          @defer (when isUpToMediumScreen()){}
          <div class="w-full block lg:hidden">
            <!-- Start::valor total -->
            <div
              class="flex justify-content-between align-items-center mb-2 text-lg text-900 font-bold"
            >
              <span>Total a pagar</span>
              <span>{{ cartService.total$ | async | currency }}</span>
            </div>
            <!-- End::valor total -->

            <!-- Start::formulario acepta términos y condiciones -->
            @if(step() === 3 && isTermsOfServiceVisible){
            <div class="mb-2">
              <form
                [formGroup]="termsOfServiceForm"
                #termsOfServiceFormElement
                (ngSubmit)="onSubmitTermsOfServiceForm()"
              >
                <app-terms-of-service-input formControlName="disclaimer" />
              </form>
            </div>
            }
            <!-- End::formulario acepta términos y condiciones -->
          </div>
          <!-- End::resumen en móvil -->

          <!-- Start::botón para ir al paso siguiente o para pagar -->
          <p-button
            (click)="submit()"
            [label]="submitButtonLabel()"
            pRipple
            class="w-full"
            styleClass="w-full"
          />
          <!-- End::botón para ir al paso siguiente o para pagar -->

          <!-- Start::botón volver al paso anterior -->
          @if(!isLoggedIn() || (isLoggedIn() && [2,3].includes(step()))){
          <p-button
            (click)="goBack()"
            [label]="backButtonLabel()"
            pRipple
            [text]="true"
            class="w-full hidden md:block"
            styleClass="w-full"
            [disabled]="loadingCotizacion"
          />
          }
          <!-- End::botón volver al paso anterior -->

          <!-- Start::generar cotización -->
          @if(isQuotationVisible && step() > 1 && isLoggedIn()){
          <div
            class="w-full text-700 font-normal text-sm text-center border-top-1 surface-border pt-2 md:pt-3 mt-2 md:mt-0"
          >
            ¿Deseas generar una cotización?
            <div
              (click)="comfirmGenerateQuotation($event)"
              class="font-medium text-blue-500 no-underline hover:text-blue-700 hover:underline cursor-pointer"
            >
              Generar cotización
            </div>
          </div>
          }
          <!-- End::generar cotización -->
        </div>
      </div>
    </div>

    <app-summary-order [step]="step()" />
  </div>
</div>
@if(step() === 3){
<app-khipu-sidebar
  #khipuSidebarComponent
  [(visibleSidebar)]="isSidebarVisible"
/>
}

<p-confirmDialog />
